import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const MarkdownParagraphRenderer = ({ children }) => (
	<Typography variant='body1' pb={{ xs: 1, md: 3 }}>
		{children}
	</Typography>
);

MarkdownParagraphRenderer.propTypes = {
	children: PropTypes.node.isRequired,
};

export default MarkdownParagraphRenderer;
